import React from "react";
import { Star } from "lucide-react";

export function StarRating({ rating = 0, size = 14, showValue = false, count }) {
  return (
    <div className="flex items-center gap-1" aria-label={`Note ${rating} sur 5`}>
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            size={size}
            className={
              i <= Math.round(rating)
                ? "fill-gold text-gold"
                : "fill-transparent text-muted-foreground/40"
            }
          />
        ))}
      </div>
      {showValue && (
        <span className="text-xs font-medium text-muted-foreground">
          {rating.toFixed(1)}
          {count != null && ` (${count})`}
        </span>
      )}
    </div>
  );
}
